<template>
    <div class="">
        <div class="profile-content">
            <div class="row">
                <div class="col-3">
                    <span>Ultima modifica  il : {{updatedAt}}</span>
                </div>
                <div class="col-3">
                    <span>Chiuso il : {{completedAt}}</span>
                </div>
            </div>
            <hr>
            <div v-if="permission && completedAt == null">
                <textarea v-model="answers.textarea" class="form-control" rows="3"></textarea>
            </div>
            <div v-else>
                <div class="readAnswersStep" style="border: 1px black solid;height: 150px;">
                    {{answers.textarea}}
                </div>
            </div>

            {{description_step}}

            <div class="question--footer" v-if="permission || can_write || completedAt !== null">
                <button class="btn btn--green" type="button" v-if="permission || can_write" @click="saveStep()">
                    <i class="fas fa-save"></i>Salva
                </button>
                <button class="btn btn-primary" type="button" v-if="permission || can_write" @click="approveStep()">
                    <i class="fas fa-arrow-right"></i>Convalida
                </button>
            </div>
        </div>
    </div>
  </template>
<script>
    export default {
        mounted() {
            this.getStepInfo();
        },
        props: {
            work_instance_step:{
                type:Number,
                required:true,
            },
            can_write:{
                type:Boolean,
                required:true,
            }
        },
        data(){
            return {
                name_step           : "",
                description_step    : "",
                answers             : [],
                permission          : false,
                dueDate             : null,
                completedAt         : null,
                updatedAt           : null,
                startedAt           : null,
                swalTitle           : "{{__('forms.workInstance.sendStepTitle')}}",
                swalBody            : "{{__('forms.workInstance.sendStepBody')}}",
            }
        },
        methods: {
            saveStep(){
            Vue.$toast.open({
              message: 'Saving in progress, don\'t close the sheet...',
              type: 'warning',
              icon: 'warning',
              position: 'top-left'
            });
            axios.put("/save-work-instance-step-data/"+this.work_instance_step+"/work-instance-step", {
              workInstanceStep :{
                answers : this.answers,
                save    : 1
              }
            })
                .then((response) => {
                  Vue.$toast.open({
                    message: 'Save Complete!',
                    type: 'success',
                    position: 'top-left'
                  });
                  this.getStepInfo();
                });
            },
            approveStep(){

                if (this.answers.textarea === null || this.answers.textarea.match(/^ *$/) !== null){
                    Vue.swal({

                        title: 'Non puoi lasciare l\'elaborazione del task vuota',
                        text: ''
                    })
                    return;
                }

                Vue.swal.fire({
                    title: "Sei sicuro di convalidare?",
                    text: "Non potrai più modificare l'elaborazione del task",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.value) {
                        axios.put("/save-work-instance-step-data/"+this.work_instance_step+"/work-instance-step", {
                            workInstanceStep :{
                                answers : this.answers,
                                approve : 1,
                            }
                        })
                        .then((response) => {
                          this.getStepInfo();
                            // let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                            // if(isChrome){
                            //     setTimeout(window.close,1000);
                            // }
                            // else{
                            //     window.close();
                            // }
                        });
                    }
                });
            },
            getStepInfo(){
                let url ="";
                axios.get("/work-instance-step-data/"+this.work_instance_step+"/work-instance-step",{params : {}})
                    .then((response) => {
                        this.name_step = response.data.name;
                        this.description_step = response.data.description;
                        this.answers = response.data.answers;
                        this.permission = response.data.permission;

                        this.dueDate = response.data.dueDate;
                        this.completedAt = response.data.completedAt;
                        this.updatedAt = response.data.updatedAt;
                        this.startedAt = response.data.startedAt;

                        console.log(response.data);
                    });
            },
        }
    }
</script>

<style>

</style>
